export default __webpack_public_path__ + "static/media/bg-1.9f42b345.jfif";